import SharePointLogo from "../../../assets/icons/SharePointLogo.svg";
import OneDriveLogo from "../../../assets/icons/OneDriveLogo.svg";
import { domain_vizr, MICROSOFTAD } from "../../../redux/constants/constants";

export const SHAREPOINT_SERVER = {
  icon: SharePointLogo,
  name: "Sharepoint",
  type: "checkbox",
};
export const ONEDRIVE_SERVER = {
  icon: OneDriveLogo,
  name: "One Drive",
  type: "checkbox",
};

export const NTFS_SERVER = {
  icon: "/dataSourceIcons/NTFS_SERVER.png",
  name: "NTFS Server",
  type: "radio",
};

export const NTFS_LOCAL = {
  icon: "/dataSourceIcons/NTFS_LOCAL.png",
  name: "NTFS Local",
  type: "radio",
};
export const DataSourceErrorMessages = {
  INVALID_DOMAIN_NAME: "Invalid Domain Name",
};
export const NTFS = "NTFS";
export const instructionTypes = [
  "SQL Server",
  "Google Drive",
  "PostgreSQL",
  "NTFS",
  "NTFS Local Endpoint",
  "MySQL",
  "MS On-Premise AD",
];
export const unMaskInstruction = {
  POSTGRESQL: "PostgreSQL",
  NTFS: "NTFS",
  MSSQL: "SQL Server",
  MYSQL: "MySQL",
  MICROSOFTAD: "MS On-Premise AD",
};
export const DOWNLOAD_NTFS_CONFIGURATION = "DOWNLOAD_NTFS_CONFIGURATION";
export const getNTFSConfiguration = (id, loc) => {
  if (loc === "NTFS_LOCAL_ENDPOINT") {
    return `${domain_vizr}/tenant/datasource/${id}/ntfsLocalEndpointConfig`;
  } else {
    return `${domain_vizr}/tenant/datasource/${id}/ntfsConfig`;
  }
};

export const SET_SCANNED_PATHS = "SET_SCANNED_PATHS";
export const SET_EXCLUDE_PATTERNS = "SET_EXCLUDE_PATTERNS";
export const SET_MAX_CPU_CAPACITY = "SET_MAX_CPU_CAPACITY";
export const SET_START_SCAN_TIME = "SET_START_SCAN_TIME";
export const SET_END_SCAN_TIME = "SET_END_SCAN_TIME";
export const SET_MAX_FILE_SIZE = "SET_MAX_FILE_SIZE";

export const NTFS_SCAN_PATHS_NOT_ALLOWED_ERROR_MESSAGE =
  "Scan paths cannot contain quotes.";
export const NTFS_EXCLUDE_PATTERNS_NOT_ALLOWED_ERROR_MESSAGE =
  "Exclude patterns cannot contain quotes.";

export const ntfsIconMap = {
  NTFS_SERVER: {
    selected: true,
    name: "NTFS Server",
    icon: "/dataSourceIcons/NTFS_SERVER.png",
    type: "radio",
  },
  NTFS_LOCAL: {
    selected: false,
    name: "NTFS Local",
    icon: "/dataSourceIcons/NTFS_LOCAL.png",
    type: "radio",
  },
};

export const SET_NTFS_ICON_MAP = "SET_NTFS_ICON_MAP";

export const downloadNTFSAgentLink = `${domain_vizr}/tenant/datasource/downloadAgent/ntfs`;
export const DOWNLOAD_NTFS_AGENT = "DOWNLOAD_NTFS_AGENT";
